// extracted by mini-css-extract-plugin
export default {"eventsSection":"events-section_eventsSection__2bCDW","container":"events-section_container__WY2Dv","header":"events-section_header__fd3Ij"};